<script setup>
import {defineProps, toRefs, computed, ref} from "vue";

const props = defineProps({
  data: {},
});
const {data} = toRefs(props);

const headingTag = computed(() => {
  if (data.value.value === '1') return 'h1';
  if (data.value.value === '2') return 'h2';
	if (data.value.value === '3') return 'h3';
	if (data.value.value === '4') return 'h4';
	if (data.value.value === '5') return 'h5';
	if (data.value.value === '6') return 'h6';
  if (data.value.value === '7') return 'h7';
  return 'div';
});
</script>

<template>
	<div>
    <component :is="headingTag">{{ data.label }}</component>
	</div>
</template>

<style lang="scss" scoped>

</style>